import { DocumentCategory } from 'enums/DocumentCategory';
import { Lender } from 'enums/ApplicationsVariables';

import { ApplicationDto } from './ApplicationApi';
import { HttpClient } from './HttpClient';

export enum ExtractionDocumentType {
  WorkOrder = 'Work Order Contract',
}

export interface UploadDocumentsRequest {
  applicationId: string;
  files: File[];
  documentVariablePrefix: string;
  documentCategory: DocumentCategory;
  extractDocument: boolean;
  documentType?: ExtractionDocumentType;
}

export interface DownloadAcceptedTranscriptAuthorizationRequest {
  firstName: string;
  lastName: string;
  ssn: string;
  streetName: string;
  streetNumber: string;
  city: string;
  state: string;
  zip: string;
}

export default class DocumentsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/documents' || '');
  }

  public async uploadDocuments({
    applicationId,
    files,
    documentVariablePrefix,
    extractDocument,
    documentType,
  }: UploadDocumentsRequest): Promise<ApplicationDto> {
    const formData = new FormData();

    formData.set('applicationId', applicationId);
    formData.set('documentVariablePrefix', documentVariablePrefix);
    formData.set('extractDocument', extractDocument.toString());

    if (documentType) {
      formData.set('documentType', documentType);
    }

    files.forEach((file) => {
      formData.append(`files`, file, file.name);
    });

    return this.instance.post(`/upload`, formData).then((response) => response.data);
  }

  public async downloadCreditServicesAgreement(applicationId: string, lender: Lender): Promise<any> {
    return this.instance
      .get(`/credit-services-agreements?applicationId=${applicationId}&lender=${lender}`)
      .then((response) => response.data);
  }

  public async downloadUnacceptedTranscriptAuthorization(): Promise<any> {
    return this.instance.get('/transcript-authorization/unaccepted').then((response) => response.data);
  }

  public async downloadAcceptedTranscriptAuthorization(
    downloadTranscriptAuthorizationRequest: DownloadAcceptedTranscriptAuthorizationRequest,
  ): Promise<any> {
    const params = new URLSearchParams();

    Object.keys(downloadTranscriptAuthorizationRequest).forEach((key) => {
      params.append(key, downloadTranscriptAuthorizationRequest[key]);
    });

    return this.instance
      .get('/transcript-authorization/accepted', { params: params })
      .then((response) => response.data);
  }
}

export const documentsApi = new DocumentsApi();
